import React from "react";
import {AdminComponent} from "./AdminComponent";
import {Dictionary} from "./Dictionary";

export abstract class FormComponent extends AdminComponent {

    protected getFormData(event: any): any {
        const data = new FormData(event.target);

        if (event.target.hasAttribute("enctype") &&
            event.target.getAttribute('enctype') === 'multipart/form-data') {
            return data;
        }

        let formData: {} | any = {};

        data.forEach((value, key, fd) => {
            if (key.substring(key.length - 2) === '[]') {
                if (typeof formData[key.substring(0, key.length - 2)] === 'undefined') {
                    formData[key.substring(0, key.length - 2)] = [];
                }
                formData[key.substring(0, key.length - 2)].push(value);
                return;
            }
            formData[key] = value;
        });

        return formData;
    }

    protected handleSubmit(event: any) {
        event.preventDefault();

        let button = event.target.querySelector('button');
        if (button.disabled === true) {
            return;
        }

        button.disabled = true;

        this.request.fetch(this.getRequestUrl(event), this.getFormData(event), {
            method: event.target.hasAttribute("method") ? event.target.getAttribute('method') : 'POST'
        }).then((data: any) => {
            button.disabled = false;
            FormComponent.checkMessages(data);
            return this.onSuccess(data, event);
        }).catch(error => {
            this.onError(error, event);
        });
    }

    static checkMessages(data: any): void {
        if (FormComponent.isStringOrStringArray(data.message)) {
            FormComponent.prepareMessages(data.message);
        }
        if (FormComponent.isStringOrStringArray(data.messages)) {
            FormComponent.prepareMessages(data.messages);
        }
        if (FormComponent.isStringOrStringArray(data.error)) {
            FormComponent.prepareMessages(data.error);
        }
    }

    protected onSuccess(data: any, event: React.FormEvent | null): any {
        if (data.message) {
            (
                document.querySelector('form .alert.alert-success') as HTMLElement
            ).innerHTML = this.dictionary.get[data.message];
        }
        (
            document.querySelector('form .alert.alert-success') as HTMLElement
        ).classList.remove('hide');
    }

    public checkboxHeaderClick(event: any) {
        const element = event.target.closest('div');
        let checked =
            element.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)').length
            < element.querySelectorAll('input[type="checkbox"]:not(:disabled)').length;
        (
            element.querySelectorAll('input[type="checkbox"]:not(:disabled)') as HTMLInputElement[]
        ).forEach((input: HTMLInputElement) => {
            input.checked = checked;
        });
    };

    static prepareMessages(responseMessages: string[] | string): void {
        const dictionary: Dictionary = new Dictionary();
        let messages: any = [];
        if (typeof responseMessages === 'object') {
            for (let i in responseMessages) {
                messages.push(dictionary.get[responseMessages[i]]);
            }
        } else {
            messages.push(dictionary.get[responseMessages]);
        }
        if (messages.length) {
            throw new Error(messages.join("<br/>"));
        }
        throw new Error(dictionary.get['unknown-error']);
    }

    static isStringOrStringArray(obj: any) {
        return typeof obj === "string" || (Array.isArray(obj) && obj.every(item => typeof item === "string"));
    }
}
